var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.6,705.5l234.3,93.5c1.5,0.6,3.1,0.9,4.6,0.9s3.2-0.3,4.6-0.9L512.7,701l237,86c4.2,1.5,8.5,2.2,12.8,2.2 c7.6,0,15.1-2.3,21.5-6.8c10-7,16-18.5,16-30.7v-522c0-15.7-9.9-29.9-24.7-35.2l-149.9-54.4c-6.5-2.3-13.7,1-16,7.5 c-2.4,6.5,1,13.6,7.5,16l149.9,54.4c4.9,1.8,8.2,6.5,8.2,11.7v522c0,4.1-1.9,7.8-5.3,10.2c-3.5,2.4-7.6,2.9-11.4,1.5L525,678.9V475 c0-6.9-5.6-12.5-12.5-12.5S500,468.1,500,475v204.2L275,769V500c0-6.9-5.6-12.5-12.5-12.5S250,493.1,250,500v269L32.9,682.3 c-4.8-1.9-7.9-6.5-7.9-11.6V149.4c0-4.2,2-8,5.5-10.3c3.5-2.4,7.7-2.8,11.7-1.3l81,32.4c6.4,2.6,13.7-0.6,16.2-7 c2.6-6.4-0.5-13.7-6.9-16.2l-81-32.4c-11.6-4.7-24.7-3.2-35,3.8c-10.3,7-16.5,18.6-16.5,31v521.3C0,686.1,9.2,699.8,23.6,705.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.4,561.7c5.7,8.4,15.3,13.3,25.4,13.3c10.2,0,19.8-5,25.5-13.4l92.4-132.7l51.8-78.9 c36.9-46.7,52.6-105.2,44.3-164.7C577.5,89.6,497.8,12.3,401.4,1.4c-130.8-14.5-242,87.3-242,214.9c0,49.9,16.2,94.2,52.4,143.4 L351.4,561.7z M376.2,25c7.4,0,14.9,0.4,22.4,1.3c85.3,9.6,155.7,78,167.5,162.5c7.3,52.7-6.6,104.4-39.8,146.5L474,414.9 l-92.3,132.5c-3.1,4.5-6.7,4.5-9.8,0L232.1,345.2c-33-44.9-47.7-84.7-47.7-129C184.3,110.8,270.4,25,376.2,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375,291.3c41.4,0,75-33.6,75-75s-33.7-75-75-75s-75,33.6-75,75S333.7,291.3,375,291.3z M375,166.3 c27.6,0,50,22.4,50,50s-22.4,50-50,50c-27.6,0-50-22.4-50-50S347.5,166.3,375,166.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4c2b6cb209986f47245111bd59a711ca.svg";
export { ForwardRef as ReactComponent };